var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-results"},[(_vm.data.text)?_c('span',{staticClass:"search-results-text",domProps:{"innerHTML":_vm._s(_vm.data.text)}}):_vm._e(),(_vm.data.text)?_c('span',[_vm._v("   ")]):_vm._e(),(_vm.data.showClearFilter)?_c('span',{staticClass:"link",on:{"click":_vm.clearFiltering}},[_vm._v(" Clear all filters ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }